import { DataModulePresenterModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace ModuleActions {
  export class FetchModules {
    static readonly type = '[Modules] Fetch Modules';
    constructor(
      public payload: {
        skip?: number;
        limit?: number;
        searchTerm?: string;
        includeCoreModule?: boolean;
        moduleId?: string;
      },
    ) {}
  }
  /**
   * fetch modules then you can read them from transitoryModules selector.
   * here selectOnce or selectSnapshot must be used, don't use any other selection methods
   */
  export class TransitoryFetchModules {
    static readonly type = '[Modules] TransitoryFetch Modules';
    constructor(
      public payload: {
        skip?: number;
        limit?: number;
        searchTerm?: string;
        moduleIds?: string[];
        includeCoreModule?: boolean;
      },
    ) {}
  }

  export class SelectModule {
    static readonly type = '[Modules] Select Module';
    constructor(public moduleId: string) {}
  }

  export class FetchModule {
    static readonly type = '[Modules] Fetch Module';
    constructor(public moduleId: string) {}
  }

  export class DeleteModule {
    static readonly type = '[Modules] Delete Module';
    constructor(public moduleId: string) {}
  }

  export class CreateModule {
    static readonly type = '[Modules] Create Module';
    constructor(public module: DataModulePresenterModel) {}
  }

  export class UpdateModule {
    static readonly type = '[Modules] Update Module';
    constructor(public module: DataModulePresenterModel) {}
  }
}
